import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  names: [],
};

const reports = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_REPORTS_NAMES_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_REPORTS_NAMES_SUCCESS: {
      return { ...state, isLoading: false, names: action.res.Data };
    }

    case actionTypes.GET_REPORTS_NAMES_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default reports;
